// src/util/stringEllipsisAtMaxCharacters.ts
var defaultLabelMaxLength = 16;
var ellipsis = "\u2026";
var stringEllipsisAtMaxCharacters = function stringEllipsisAtMaxCharacters(stringToTruncate) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLabelMaxLength;
  return stringToTruncate.length > maxLength ? "".concat(stringToTruncate.substr(0, maxLength - 1), " ").concat(ellipsis) : stringToTruncate;
};
export { stringEllipsisAtMaxCharacters };